/**
 * Merchant home (`/home`) vocabulary: greeting, next-step prompts, recent
 * activity and empty states. Assembled into `WorkspaceCopy` by `../copy.ts`.
 */

export const homeCopyEn = {
  home: {
    greet: ['Good morning', 'Good afternoon', 'Good evening'],
    intro: 'Here is what needs you, and what Mouja is working on.',
    newLine: 'Start a video',
    attention: 'Needs your attention',
    attentionProfile:
      'Confirm what Mouja understood about your business so the analysis can start.',
    attentionFailed:
      'The last video could not be created. Try again or choose a different direction.',
    attentionRecs: 'Analysis is complete. Choose one of three creative directions.',
    attentionCard: 'Your Content Card is ready. Review it and tell Mouja to make it.',
    activeLines: 'Active projects',
    noLines: (ws: string) => `No projects yet in ${ws}.`,
    recentVideos: 'Recently completed videos',
    noVideos: 'No completed videos yet in this workspace. Finished videos appear here.',
    profile: 'Business Profile',
    profileConfirmed: 'Confirmed from your intake',
    profileDraft: 'Awaiting confirmation',
    profileMissing: 'Your business summary will appear here once available.',
    profileShared:
      'Your confirmed profile provides the business context for content research.',
    viewAllVideos: 'View all videos',
    sections: (done: number, total: number) =>
      `${String(done)} of ${String(total)} sections`,
    profileComplete: 'Profile complete',
    profilePct: (pct: number) => `Profile ${String(pct)}% complete`,
    hintTaste:
      'Creative taste calibration is coming soon. Recommendations use a neutral style until then.',
    hintOffers: 'Add at least one concrete offer so recommendations stay specific.',
    hintDone:
      'Everything Mouja needs is in place. Review it whenever your business changes.',
    reviewProfile: 'Review Business Profile',
    addOffer: 'Add offer',
    summaryUnavailable: 'The workspace summary could not be loaded right now.',
  },
};

export const homeCopyAr: typeof homeCopyEn = {
  home: {
    greet: ['صباح الخير', 'مساء الخير', 'مساء الخير'],
    intro: 'هذا اللي يحتاجك، وهذا اللي موجة شغالة عليه الحين.',
    newLine: 'ابدأ فيديو',
    attention: 'يحتاج انتباهك',
    attentionProfile: 'أكّد اللي فهمته موجة عن نشاطك عشان يبدأ التحليل.',
    attentionFailed: 'ما قدرنا نسوي آخر فيديو. جرّب مرة ثانية أو اختر اتجاه ثاني.',
    attentionRecs: 'خلص التحليل. اختر واحد من الاتجاهات الإبداعية.',
    attentionCard: 'بطاقة المحتوى جاهزة. راجعها وقول لموجة تسويها.',
    activeLines: 'المشاريع النشطة',
    noLines: (ws: string) => `ما فيه مشاريع لين الحين في ${ws}.`,
    recentVideos: 'آخر الفيديوهات المكتملة',
    noVideos:
      'ما فيه فيديوهات مكتملة لين الحين في مساحة العمل هذي. بتظهر هنا أول ما تخلص.',
    profile: 'الملف التجاري',
    profileConfirmed: 'مؤكّد من بيانات نشاطك',
    profileDraft: 'بانتظار التأكيد',
    profileMissing: 'بيظهر ملخص نشاطك هنا أول ما يتوفر.',
    profileShared: 'ملفك المؤكّد يوفّر معلومات النشاط لبحث المحتوى.',
    viewAllVideos: 'عرض كل الفيديوهات',
    sections: (done: number, total: number) =>
      `${String(done)} من ${String(total)} أقسام`,
    profileComplete: 'الملف مكتمل',
    profilePct: (pct: number) => `الملف مكتمل بنسبة ${String(pct)}٪`,
    hintTaste:
      'معايرة الذوق الإبداعي جايه قريب. لين ذاك الوقت التوصيات تستخدم أسلوب محايد.',
    hintOffers: 'ضيف على الأقل عرض واحد واضح عشان تبقى التوصيات محددة.',
    hintDone: 'كل اللي تحتاجه موجة جاهز. راجعه كل ما تغيّر شي في نشاطك.',
    reviewProfile: 'راجع الملف التجاري',
    addOffer: 'ضيف عرض',
    summaryUnavailable: 'ما قدرنا نحمّل ملخص مساحة العمل الحين.',
  },
};
